<!-- 模块-切换油卡 -->
<template>
  <span>
    <van-cell-group style="margin-top: 5px;">
      <van-cell v-if="not_card" title="开通油卡可享受优惠" value="办理油卡" @click="show = true" size="large"  is-link class="more"/>
      <span v-else>
        <van-cell v-if="if_use" icon="debit-pay" :title="'No.' + card_no" :value="money" size="large" is-link @click="ifShow = true" />
        <van-cell v-else size="large" title="该卡在此站点无法使用" value="切换油卡" is-link @click="ifShow = true"></van-cell>
      </span>
    </van-cell-group>

    <!-- 选中油卡 -->
    <van-popup v-model="ifShow" position="bottom" round >
      <div class="popup_tit">
        <span>选择油卡</span>
        <van-button type="default" round size="small" @click="ifShow = false">取 消</van-button>
      </div>
      <div class="card_list">
        <cardT v-for="(val, key) in data" :key="key" :data="val" @click.native="on(val)" />
      </div>
    </van-popup>

   <!--  -->
    <van-action-sheet v-model="show" :actions="actions" cancel-text="取消" description="请选择您的办卡类型" close-on-click-action @select="select"/>

    <!-- 子组件 -->
    <reg ref="reg" @up_data="get_data" />
    <intoDel ref="into_del" @up_data="get_data" />
  </span>
</template>

<style lang="scss">
  .card_list {
    padding: 15px;
  }
</style>

<script>
import cardT from '@/components/card/card_template'
import reg from '@/components/card/reg'
import intoDel from '@/components/card/into_del'

export default {
  name: 'oiling_card',
  props: ['s_id'],
  components: {cardT, reg, intoDel},
  data () {
    return {
      data: [],
      on_data: null,
      card_name: '油卡',
      card_no: '00000000',
      money: '0.00',
      ifShow: false,
      not_card: true,
      if_use: true,
      show: false,
      actions: [
        {type: 1, name: '绑定实卡'},
        {type: 2, name: '一键办卡'}
      ]
    }
  },

  methods: {
    // 获取数据
    get_data () {
      this.ax(this, 'sel_web_card_user', {}, (res) => {
        if (res.err_num === 0) {
          this.$emit('get_recharge', res.data.if_recharge)
          if (res.data.card_data.length === 0) {
            // 没卡
            this.not_card = true
            this.$emit('get_card_data', false)
          } else {
            // 有卡
            this.not_card = false
            this.data = res.data.card_data
            this.on_data = this.data[0]
            // 判断默认卡是否在该站点可用
            if (this.ver_use()) {
              this.set_show()
              this.$emit('get_card_data', this.on_data)
            } else {
              this.$emit('get_card_data', false)
            }
          }
        }
      })
    },

    // 计算显示内容
    set_show () {
      this.card_name = this.on_data.type_name
      this.card_no = this.on_data.card_no
      this.money = this.on_data.money
    },

    // 验证当前卡是否在在当前站点使用
    ver_use () {
      let arr = JSON.parse(JSON.stringify(this.on_data.limit_site))
      if (arr.indexOf(this.s_id) < 0) {
        this.$notify({ type: 'warning', message: '该卡不能在此站点使用' })
        this.if_use = false
        return false
      } else {
        this.if_use = true
        return true
      }
    },

    // 选中卡
    on (data) {
      if (typeof data.msg.IC_CardID !== 'undefined') {
        this.$notify({ type: 'warning', message: '实体卡不能在此站点使用' })
        return false
      }

      this.on_data = data
      if (this.ver_use()) {
        this.ifShow = false
        this.set_show(data)
        this.$emit('get_card_data', data)
      } else {
        this.$emit('get_card_data', false)
      }
    },

    // 选择办理油卡类型
    select (val) {
      if (val.type === 1) {
        this.$refs.into_del.show({type: 1})
      } else {
        this.$refs.reg.show()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/oiling/card.vue